module.exports = __webpack_public_path__ + "img/icon-close.fd2d096f.svg";